import { userConstants } from './user.constants'

const user = JSON.parse(localStorage.getItem('user') || null)
const initialState = user
  ? { loggedIn: true, user, error: '' }
  : {
      user: null,
      userEmail: null,
      error: null,
      loading: false,
    }

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      }
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
      }
    case userConstants.LOGIN_FAILURE:
      return {
        loggedIn: false,
        error: 'Feil brukernavn og/eller passord',
      }

    case userConstants.FORGOT_PASSWORD_REQUEST:
      return {
        loading: true,
      }
    case userConstants.FORGOT_PASSWORD_SUCCESS:
      return {
        loading: false,
      }
    case userConstants.FORGOT_PASSWORD_FAILURE:
      return {
        loading: false,
        error: action.error,
      }

    case userConstants.VALIDATE_FORGOT_PASSWORD_TOKEN_SUCCESS:
      return {
        userEmail: action.email,
      }

    case userConstants.VALIDATE_FORGOT_PASSWORD_TOKEN_FAILURE:
      return {
        error: action.error,
      }

    case userConstants.COMPLETE_FORGOT_PASSWORD_FAILURE:
      return {
        error: action.error,
      }

    case userConstants.LOGOUT:
      return {}
    case userConstants.CHECK_REGISTRATION_TOKEN:
      return {
        ...state,
        loading: true,
      }
    case userConstants.CHECK_REGISTRATION_TOKEN_SUCCESS:
      return {
        ...state,
        user: action.user,
        loading: false,
      }

    case userConstants.CHECK_REGISTRATION_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case userConstants.CHECK_TWO_STEP_VERIFICATION_TOKEN:
      return {
        ...state,
        loading: true,
      }
    case userConstants.CHECK_TWO_STEP_VERIFICATION_TOKEN_SUCCESS:
      return {
        ...state,
        user: action.user,
        loading: false,
      }

    case userConstants.CHECK_TWO_STEP_VERIFICATION_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case userConstants.TWO_STEP_VERIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case userConstants.TWO_STEP_VERIFICATION_SUCCESS:
      return {
        loading: false,
        loggedIn: true,
        user: action.user,
      }

    case userConstants.TWO_STEP_VERIFICATION_ERROR:
      return {
        ...state,
        loading: false,
        loggedIn: false,
        error: action.error,
      }

    case userConstants.REGISTRATION_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case userConstants.REGISTRATION_SUCCESS:
      return {
        ...state,
        user: null,
        loading: false,
      }

    case userConstants.REGISTRATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    default:
      return state
  }
}
